// Paint predicate for the QC-advisory red outline.
//
// Source of truth is the server flag `qcAdvisoryOutline` (QC-1
// summarizeVisionQc). When that key is absent (pre-QC-1 payload), fall
// back to inspected && passed === false && !qcOverridden. Never read
// `status` or `phase` — after QC-1 an inspected fail is a delivered
// draft, and after override-qc `phase` can still say `qc-advisory`.

/** Same four keys as adgen/backend CATEGORIES (adVisionQcService.js). */
export const QC_CATEGORY_ORDER = [
  'competitor_marks',
  'product_fidelity',
  'text_defects',
  'layout_safe_box'
] as const;

export type QcCategoryKey = (typeof QC_CATEGORY_ORDER)[number];

export const QC_CATEGORY_LABELS: Record<QcCategoryKey, string> = {
  competitor_marks: 'Competitor marks',
  product_fidelity: 'Product fidelity',
  text_defects:     'Text defects',
  layout_safe_box:  'Layout safe box'
};

/** Backend PASS_FLOOR. Tint a score only — never re-derive pass. */
export const PASS_FLOOR = 7;

export type QcCategoryScore = {
  score: number | null;
  pass: boolean;
  findings: string[];
  caveat?: string;
};

export type QcVisionSummary = {
  inspected?: boolean;
  passed?: boolean;
  skipped?: boolean;
  disabled?: boolean;
  summary?: string | null;
  failureDetail?: string | null;
  categories?: Record<string, QcCategoryScore>;
};

export function shouldPaintQcOutline(ad: {
  qcAdvisoryOutline?: boolean;
  qcOverridden?: boolean;
  visionQc?: QcVisionSummary | null;
}): boolean {
  if (typeof ad.qcAdvisoryOutline === 'boolean') return ad.qcAdvisoryOutline;
  const qc = ad.visionQc;
  if (!qc) return false;
  const inspected = qc.inspected === true && !qc.skipped && !qc.disabled;
  return !!(inspected && qc.passed === false && !ad.qcOverridden);
}
